import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

async function backfillSBOMSummaryData(): Promise<void> {
  await post('/api/organizations/backfill-sbom-summary-data', {});
}

/**
 * Hook to backfill SBOM summary data for the current organization.
 * @returns Mutation function to trigger SBOM summary data backfill
 */
export const useBackfillSBOMSummaryData = () => {
  return useToastedMutation({
    mutationFn: backfillSBOMSummaryData,
    successToastMessage: 'SBOM summary data backfill queued successfully',
    errorToastMessage: 'Failed to queue SBOM summary data backfill',
  });
};
